<template>
    <app-layout title="Edit Loads">
        <form @submit.prevent="handleSubmit">
            <page-header>
                <template #title>Edit Loads</template>

                <template #actions>
                    <jet-button v-show="form.isDirty" type="submit" class="leading-none" :disabled="form.processing" >
                        Save
                    </jet-button>

                    <jet-tertiary-button
                        v-if="form.isDirty"
                        :disabled="form.processing"
                        class="leading-none"
                        @click="showUnsavedChangesModal = true"
                    >
                        Cancel
                    </jet-tertiary-button>

                    <jet-tertiary-button
                        v-else
                        :disabled="form.processing"
                        :href="backUrl"
                        class="leading-none"
                    >
                        Close
                    </jet-tertiary-button>
                </template>
            </page-header>

            <load-form
                :form="form"
                :load="load"
                :is_edit="true"
                :locations="locations"
                class="px-3 md:px-4 lg:px-8"
            />

            <div class="flex flex-col px-3 md:px-4 lg:px-8 gap-y-4 ">
                <div v-if="load">
                    <load-order-edit 
                        :form="form"
                        :load_id="form.id"
                        :load_type="form.type"
                    />
                </div>
            </div>
        </form>

        <unsaved-changes-modal-2
            :formRoute="formRoute"
            :isDirty="form.isDirty"
            :show="showUnsavedChangesModal"
            @close="showUnsavedChangesModal = false"
            @confirm="$inertia.get(backUrl)"
        />
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import LoadForm from '@/Pages/Loads/Partials/LoadForm.vue';
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal';
import UnsavedChangesModal2 from '@/Shared/UnsavedChangesModal2';
import LoadOrderEdit from '@/Pages/Loads/Partials/LoadOrderEdit.vue';
import { DateTime } from 'luxon';

export default {
    setup(props) {
        const form = useForm({
            id: props.load.id,
            date: new Date(props.load.date + ' EST'),
            route_type: props.load.route_type,
            route: props.load.route,
            truck: props.load.truck,
            driver: props.load.driver,
            departure_time: props.load.departure_time,
            type: props.load.type,
            location_id: props.load.location_id,
            shipping_time: props.load.shipping_time,
            load_orders: props.load.load_orders.map(i => {
                return {
                    id: i.id,
                    load_id: i.load_id,
                    order_id: i.order_id,
                    description: i.description,
                    load_order_index: i.load_order_index,
                    delivery_order_index: i.delivery_order_index,
                    order: i.order,
                }
            }),
        })

        return { form }
    },

    components: {
        AppLayout,
        PageHeader,
        LoadForm,
        JetButton,
        JetTertiaryButton,
        JetConfirmationModal,
        UnsavedChangesModal2,
        LoadOrderEdit,
    },

    props: [
        'load',
        'locations',
    ],

    data() {
        return {
            formRoute: this.route('loads.update', this.load.id),
            showUnsavedChangesModal: false,
        }
    },

    methods: {
        handleSubmit () {
            if(!this.form.processing) {
                const returnUrl = route().params.return;

                this.form
                    .transform((data) => ({
                        ...data,
                        date: data.date ? this.formatDate(data.date) : null,
                    }))
                    .submit('put', route('loads.update', {
                        load: this.load.id,
                        return: returnUrl,
                    }));
            }
        },

        formatDate (date) {
            // Takes a Javascript date object and returns it in formay 'YYYY-MM-DD'
            return date.toISOString().split('T')[0];
        },
    },

    computed: {
        backUrl () {
            const params = route().params;

            if (params.return) {
                return params.return;
            }

            return route('loads.index', {
                page: this.$page.props.page.orders,
            });
        },
    },
}
</script>

<style>
.multi-custom {
    min-height: 1.5rem;
}
</style>
